import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch } from "react-redux";
import { destinationActions } from "../../store/slices/destinationSlice";
import { enqueueSnackbar } from "notistack";
import PassengerActionButton from "./PassengerActionButton";

const PassengerDestinationActions = ({
  setCity,
  setCityAnother,
  value,
  enumValue,
}) => {
  const dispatch = useDispatch();

  const showSelect = () => {
    setCity("");
    setCityAnother("");
  };

  const createDestination = () => {
    showSelect();

    dispatch(
      destinationActions.createDestinationsPost({
        name: value,
        destinationType: enumValue,
        onSuccess: createDestinationSuccess,
        onError: createDestinationError,
      })
    );
  };

  const createDestinationSuccess = () => {
    enqueueSnackbar("Uspešno dodata lokacija!", { variant: "success" });
  };

  const createDestinationError = (error) => {
    enqueueSnackbar(
      "Destinacija već postoji ili je došlo do greške. Pokušajte ponovo.",
      { variant: "error" }
    );
  };

  return (
    <>
      <PassengerActionButton handleClick={showSelect} icon={<ClearIcon />} />
      <PassengerActionButton
        handleClick={createDestination}
        icon={<CheckIcon />}
      />
    </>
  );
};

export default PassengerDestinationActions;
